import { actionCreator } from '@ntersol/state-management';
import { MapModels } from '../..';

export const mapActions = {
    stateChange: actionCreator<Partial<MapModels.State>>('MAP_STATE_CHANGED'),
};
